import type { JSX } from 'react';
import { PaymentChannel } from '../models/PaymentChannel.ts';
import { Localized } from 'dg-web-shared/lib/Localization.tsx';

export function PaymentChannelLocalized({
    paymentChannel,
}: {
    paymentChannel: PaymentChannel;
}): JSX.Element {
    switch (paymentChannel) {
        case PaymentChannel.COOP:
            return <Localized de="Coop" fr="Coop" it="Coop" en="Coop" />;
        case PaymentChannel.EASYPARK:
            return (
                <Localized
                    de="EasyPark"
                    fr="EasyPark"
                    it="EasyPark"
                    en="EasyPark"
                />
            );
        case PaymentChannel.PARKINGPAY:
            return (
                <Localized
                    de="Parkingpay"
                    fr="Parkingpay"
                    it="Parkingpay"
                    en="Parkingpay"
                />
            );
        case PaymentChannel.TWINT:
            return <Localized de="TWINT" fr="TWINT" it="TWINT" en="TWINT" />;
        case PaymentChannel.SWISSPASS:
            return (
                <Localized
                    de="SwissPass"
                    fr="SwissPass"
                    it="SwissPass"
                    en="SwissPass"
                />
            );
        case PaymentChannel.TCS:
            return <Localized de="TCS" fr="TCS" it="TCS" en="TCS" />;
        case PaymentChannel.PARK_AND_RAIL_WEBVIEW:
            return (
                <Localized de="P+Rail" fr="P+Rail" it="P+Rail" en="P+Rail" />
            );
        case PaymentChannel.PARKINGABO:
        case PaymentChannel.PARKINGABO_COUNTER:
            return (
                <Localized
                    de="Parkingabo"
                    fr="Parkingabo"
                    it="Parkingabo"
                    en="Parkingabo"
                />
            );
        case PaymentChannel.QUICKCHECKOUT:
            return (
                <Localized
                    de="Quick-Checkout"
                    fr="Quick-Checkout"
                    it="Quick-Checkout"
                    en="Quick-Checkout"
                />
            );
        case PaymentChannel.PARKINGPORTAL_COUNTER:
            return (
                <Localized
                    de="Parkingportal"
                    fr="Parkingportal"
                    it="Parkingportal"
                    en="Parkingportal"
                />
            );
        case PaymentChannel.FZAG_PORTAL:
            return (
                <Localized
                    de="Flughafen"
                    fr="Flughafen"
                    it="Flughafen"
                    en="Flughafen"
                />
            );
        case PaymentChannel.PAY_STATION:
            return (
                <Localized de="Kasse" fr="Caisse" it="Cassa" en="Pay station" />
            );
        case PaymentChannel.TOM:
            return (
                <Localized de="TOMeco" fr="TOMeco" it="TOMeco" en="TOMeco" />
            );
    }
}
